import React from 'react';
import { AlertTriangle } from 'lucide-react';

const AttendanceAlertsWidget = ({ mentees = [] }) => {
  const lowAttendance = mentees.filter(m => m.attendance?.overallPercentage < 75);

  return (
    <div className="space-y-3">
      {lowAttendance.length === 0 ? (
        <div className="text-center py-8">
          <p className="text-green-600 font-semibold">✓ All mentees have good attendance</p>
        </div>
      ) : (
        lowAttendance.map(mentee => (
          <div key={mentee.rollNumber} className="p-3 bg-red-50 border border-red-200 rounded-lg flex items-start space-x-3">
            <AlertTriangle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
            <div>
              <p className="font-semibold text-gray-900">{mentee.firstName} {mentee.surname}</p>
              <p className="text-sm text-gray-600">{mentee.rollNumber}</p>
              <p className="text-sm text-red-600 mt-1">
                {mentee.attendance?.overallPercentage?.toFixed(2)}% attendance
              </p>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default AttendanceAlertsWidget;